import React from 'react';
import { Container, Button } from 'react-bootstrap';

const CTA = ({ scrollToSection }) => {
  return (
    <section className="section cta-section text-center">
      <Container>
        <h2>Ready to Start Your Project?</h2>
        <p className="mb-4">Contact us today to discuss your requirements and get a free quote.</p>
        <Button 
          variant="primary" 
          size="lg"
          onClick={() => scrollToSection('contact')}
        >
          Contact Us
        </Button>
      </Container>
    </section>
  );
};

export default CTA;
